import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ReportsPage } from '@/features/reports/ReportsPage';
import { reportsSearch, toAddress } from '@/features/reports/search';

/* Reports (ALS-85, ALS-86, ALS-87, ALS-88, ALS-89, ALS-91, ALS-160); what the address carries, and how, is features/reports/search.ts. */
export const Route = createFileRoute('/_app/reports')({
    validateSearch: (search) => reportsSearch.parse(search),
    component: ReportsRoute,
});

function ReportsRoute() {
    const { tab, period, view, rmId, inactive, brand, quarter, days, weeks, lookbook, ...queue } =
        Route.useSearch();
    const navigate = useNavigate();
    return (
        <ReportsPage
            search={{
                tab,
                period,
                view,
                rmId,
                inactiveDays: inactive,
                brand,
                quarter,
                days,
                weeks,
                lookbookId: lookbook,
                queue,
            }}
            onChange={(next) =>
                void navigate({ to: '/reports', search: toAddress(next), resetScroll: false })
            }
        />
    );
}
